function initiateCarousel() {
  const slider = document.querySelector(".carousel-tracker");
  const slides = document.querySelectorAll(".carousel-slide");
  const nextButton = document.querySelector(".next-btn");
  const prevButton = document.querySelector(".prev-btn");
  const slideWidth = slides[0].clientWidth + 20;
  const totalSlides = slides.length;
  let currentSlide = 0;

  let slidesPerPage = 4;
  // let dotsCount = slides.length - 3;
  if (window.innerWidth < 1200) {
    slidesPerPage = 3;
  }
  if (window.innerWidth < 991) {
    slidesPerPage = 2;
    // dotsCount = slides.length - 1;
  }
  if (window.innerWidth < 767) {
    slidesPerPage = 1;
    // dotsCount = slides.length;
  }

  if (totalSlides === 4 && slidesPerPage === 4) {
    nextButton.style.display = "none";
    prevButton.style.display = "none";
    // dots.style.display = "none";
  }

  // Function to move the slider
  function moveSlide() {
    slider.style.transform = `translateX(-${currentSlide * slideWidth}px)`;
  }

  // Move to the next slide
  function nextSlide() {
    if (currentSlide === totalSlides - slidesPerPage) {
      currentSlide = 0;
    } else {
      currentSlide++;
    }
    moveSlide();
  }

  // Move to the previous slide
  function prevSlide() {
    if (currentSlide === 0) {
      currentSlide = totalSlides - slidesPerPage;
    } else {
      currentSlide--;
    }
    moveSlide();
  }

  let touchendX = 0;
  let touchstartX = 0;
  let touchThreshold = 50; // adjust this value as needed

  slider.addEventListener("touchstart", (event) => {
    touchstartX = event.changedTouches[0].screenX;
  });

  slider.addEventListener("touchend", (event) => {
    touchendX = event.changedTouches[0].screenX;
    let diff = touchendX - touchstartX;
    if (diff > touchThreshold) {
      prevSlide();
    } else if (diff < -touchThreshold) {
      nextSlide();
    }
  });

  // Add event listeners for the next and previous buttons

  nextButton.addEventListener("click", nextSlide);
  prevButton.addEventListener("click", prevSlide);
}

initiateCarousel();

// LIGHTBOX GALLERY LOGIC

const imageData = [
  {
    listName: "list_1",
    images: [
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/01-colectia-Botanee-01-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/01-colectia-Botanee-02-2023-09-15.jpg",
    ],
  },
  {
    listName: "list_2",
    images: [
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/02-colectia-En-Voyage-01-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/02-colectia-En-Voyage-02-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/02-colectia-En-Voyage-03-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/02-colectia-En-Voyage-04-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/02-colectia-En-Voyage-05-2023-09-15.jpg",
    ],
  },
  {
    listName: "list_3",
    images: [
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/03-colectia-Li-River-01-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/03-colectia-Li-River-02-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/03-colectia-Li-River-03-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/03-colectia-Li-River-04-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/03-colectia-Li-River-05-2023-09-15.jpg",
    ],
  },
  {
    listName: "list_4",
    images: [
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/04-colectia-Pamplona-01-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/04-colectia-Pamplona-02-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/04-colectia-Pamplona-03-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/04-colectia-Pamplona-04-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/04-colectia-Pamplona-05-2023-09-15.jpg",
    ],
  },
  {
    listName: "list_5",
    images: [
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/05-colectia-Bliss-01-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/05-colectia-Bliss-02-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/05-colectia-Bliss-03-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/05-colectia-Bliss-04-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/05-colectia-Bliss-05-2023-09-15.jpg",
    ],
  },
  {
    listName: "list_6",
    images: [
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/06-colectia-Dazzling-01-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/06-colectia-Dazzling-02-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/06-colectia-Dazzling-03-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/06-colectia-Dazzling-04-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/06-colectia-Dazzling-05-2023-09-15.jpg",
    ],
  },
  {
    listName: "list_7",
    images: [
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/07-colectia-Poem-01-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/07-colectia-Poem-02-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/07-colectia-Poem-03-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/07-colectia-Poem-04-2023-09-15.jpg",
      "https://cdn.shopify.com/s/files/1/0021/3041/1580/files/07-colectia-Poem-05-2023-09-15.jpg",
    ],
  },
];
const lightboxButtons = document.querySelectorAll(
  "section.hero_carousel .carousel-slider .carousel-item .carousel-button"
);
const lightbox = document.querySelector("section.hero_carousel .lightbox");
const thumbnailsNav = document.querySelector(
  "section.hero_carousel .lightbox .thumbnails"
);
const mainImage = document.querySelector(
  "section.hero_carousel .lightbox .main-image"
);
const lightboxNextBtn = document.querySelector(
  "section.hero_carousel .lightbox .lightbox-next-btn"
);
const lightboxPrevBtn = document.querySelector(
  "section.hero_carousel .lightbox .lightbox-prev-btn"
);
const body = document.querySelector("body");

const closeButton = document.createElement("span");
closeButton.classList.add("close-button");
closeButton.innerHTML =
  '<svg height="20px" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>';
lightbox.appendChild(closeButton);

lightboxButtons.forEach((button) => {
  button.addEventListener("click", () => {
    lightbox.style.display = "flex";
    body.style.overflow = "hidden";

    const listName = button.dataset.list;

    const listData = imageData.find((list) => list.listName === listName);

    mainImage.src = listData.images[0];

    thumbnailsNav.innerHTML = "";

    listData.images.forEach((image) => {
      const img = document.createElement("img");
      img.src = image;
      img.classList.add("thumbnail");

      thumbnailsNav.appendChild(img);
    });

    let activeThumb = thumbnailsNav.querySelector(".thumbnail");
    activeThumb.classList.add("active");
    setTimeout(() => {
      activeThumb.style.border = "2px solid #f60";
    }, 500);

    let currentIndex = 0;

    function handleThumbnailAndImage(index) {
      if (activeThumb) {
        activeThumb.classList.remove("active");
        activeThumb.style.border = "";
      }
      activeThumb = thumbnailsNav.children[index];
      activeThumb.classList.add("active");
      activeThumb.style.border = "2px solid #f60";

      mainImage.style.transition = "opacity 0.3s ease-in-out";
      mainImage.style.opacity = 0;
      setTimeout(() => {
        mainImage.src = listData.images[index];
        mainImage.style.opacity = 1;
      }, 300);
    }

    thumbnailsNav.querySelectorAll(".thumbnail").forEach((thumb) => {
      thumb.addEventListener("click", (e) => {
        e.stopPropagation();
        e.preventDefault();
        currentIndex = Array.from(thumbnailsNav.children).indexOf(thumb);

        thumbnailsNav.querySelectorAll(".thumbnail").forEach((thumb) => {
          thumb.style.border = "";
        });

        handleThumbnailAndImage(currentIndex);
      });
    });

    let lightboxTouchendX = 0;
    let lightboxTouchstartX = 0;
    let lightboxTouchThreshold = 50; // Adjust this value as needed

    lightbox.addEventListener("touchstart", (event) => {
      lightboxTouchstartX = event.changedTouches[0].screenX;
    });

    lightbox.addEventListener("touchend", (event) => {
      lightboxTouchendX = event.changedTouches[0].screenX;
      let diff = lightboxTouchendX - lightboxTouchstartX;

      if (diff > lightboxTouchThreshold) {
        currentIndex--;
        if (currentIndex < 0) {
          currentIndex = listData.images.length - 1;
        }
      } else if (diff < -lightboxTouchThreshold) {
        currentIndex++;
        if (currentIndex >= listData.images.length) {
          currentIndex = 0;
        }
      }
      handleThumbnailAndImage(currentIndex);
    });

    lightboxNextBtn.addEventListener("click", () => {
      currentIndex++;
      if (currentIndex >= listData.images.length) {
        currentIndex = 0;
      }
      thumbnailsNav.querySelectorAll(".thumbnail").forEach((thumb) => {
        thumb.style.border = "";
      });
      handleThumbnailAndImage(currentIndex);
    });

    lightboxPrevBtn.addEventListener("click", () => {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = listData.images.length - 1;
      }
      thumbnailsNav.querySelectorAll(".thumbnail").forEach((thumb) => {
        thumb.style.border = "";
      });
      handleThumbnailAndImage(currentIndex);
    });
  });
});

lightbox.addEventListener("click", (event) => {
  if (event.target === event.currentTarget) {
    lightbox.style.display = "none";
    body.style.overflow = "auto";
    mainImage.src = "";
    thumbnailsNav.innerHTML = "";
    currentIndex = 0;
  }
});
closeButton.addEventListener("click", () => {
  lightbox.style.display = "none";
  body.style.overflow = "auto";
  mainImage.src = "";
  thumbnailsNav.innerHTML = "";
  currentIndex = 0;
});
